import { data } from '../../svg/Move/data';
import { makeIcon } from '../makeIcon';

export const Move = makeIcon(data, 'move', 'Move');

export default Move;
